import { render } from "./Reservation_settings.vue?vue&type=template&id=462b4282&scoped=true"
import script from "./Reservation_settings.vue?vue&type=script&lang=js"
export * from "./Reservation_settings.vue?vue&type=script&lang=js"

import "./Reservation_settings.vue?vue&type=style&index=0&id=462b4282&lang=scss&scoped=true"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462b4282"]])

export default __exports__